import { Component, OnInit, Input, ViewContainerRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { NewInspectionService } from '../../inpsection.service';
import {
  InspectedImplementsViewModel,
  InspectionObservationPointsViewModel,
  SchematicsViewModel,
  PhotoModelComingFrom,
  CommentModelComingFrom,
  ObservationImagesViewModel,
  QuestionModelComingFrom,
  InspectImplementQuestionViewModel,
  InspectImplementAnswersViewModel,
  ImplementInspectionImageViewModel,
  GeneralQuestionImageViewModel,
  InspectionOverallCommentUpdateCommentViewModel
} from '../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ObservationQuestionsComponent } from './components/observation-questions/observation-questions.component';
import { LoadingService } from '../../../../../shared/services/loading.service';
import { GETViewPhotoComponent } from '../../../shared/view-photo/view-photo.component';
import { FormControl, FormGroup } from '@angular/forms';
import { EquipmentDetailsService } from '../../../equipment-details/equipment-details.service';
import { AppService } from '../../../../../app.service';
import { OrdinalDateAdapter, ORD_DATE_FORMATS } from '../../../adapters/ordinal-date-adapter';
import { ImplementDetailsService } from '../../../implement-details/implement-details.service';
import { ComponentObservationPointDetails, ImplementForEquipmentDetails, SchematicAndObservationPointDetails } from '../../../equipment-details/equipment-details.model';
import { ObservationPointVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { AddCrackObsPointDialogComponent } from '../../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { ComponentVM } from '../../../setup-implement/setup-implement.model';
import { SetupImplementService } from '../../../setup-implement/setup-implement.service';
import { GETInventoryService } from '../../../services/inventory.service';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { GETPreferencesService } from '../../../../GET_NEW_UI/preferences/preferences.service';
import { Router } from '@angular/router';
import { EquipmentDetailsParams } from '../../../setup-equipment/setup-equipment.model';
import { from, of } from 'rxjs';
import { concatMap, delay, tap } from 'rxjs/operators';
import { ManageEquipmentService } from '../../../../manage-equipment/manage-equipment.service';
import { SMUValidationCheckRequest } from '../../../../manage-equipment/models/manage-equipment.model';

@Component({
  selector: 'implement-inspection-section',
  templateUrl: './implement-inspection-section.component.html',
  styleUrls: ['./implement-inspection-section.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
  ]

})
export class ImplementInspectionSectionComponent implements OnInit {

  @Input()
  selectedImplmentId: number; // temp

  @Input()
  EquipmentID: number; // temp

  @Input()
  UnitNumber: string = ""; // temp


  @Input()
  isCreatingInspection = false;
  @Input()
  implementToBeInspected: InspectedImplementsViewModel;
  //appUris: AppUris;
  wearStyleId: number;
  originalCopy: InspectedImplementsViewModel;
  measurementOnDisplay: number;
  minDate2: Date = new Date();
  maxDateForAction: Date = new Date();
  selectedSchematic: number = -999;

  smuControl: FormControl;
  inspectionDateControl: FormControl;
  formGroup: FormGroup;


  commentComingFrom: CommentModelComingFrom;
  questionComingFrom: QuestionModelComingFrom;
  inspectionImages: PhotoModelComingFrom;
  inspectiongeneralQuestionImage: PhotoModelComingFrom;
  observationImagesOnObservation: PhotoModelComingFrom;
  IsOnEquipment: boolean = false;

  selectedReportGroup: number = -1;

  OverallComment: boolean;
  OBSseverity

  //TT-5753
  ImplementID: number = 0
  ImplementForEquipmentDetails: ImplementForEquipmentDetails[] = [];
  SchematicAndObservationPointList: SchematicAndObservationPointDetails[]
  implementInspectionID: number = 0
  @Output() updateObs: EventEmitter<boolean> = new EventEmitter();
  isLoading: boolean = false
  currentSMU: number;
  implementImage: any;
  CrackSeverityList: boolean;
  crackObsList: boolean;
  userPref: string;

  renderIds: number[] = [];
  //currentIndex = 0;

  constructor(
    private _moduleService: ImplementDetailsService,
    private _implementService: SetupImplementService,
    private _inspectionService: NewInspectionService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _loadingService: LoadingService,
    public _inventoryService: GETInventoryService,
    private _toaster: NotificationsService,
    private _appService: AppService,
    private _notification: NotificationsService,
    public toastr: NotificationsService, vcr: ViewContainerRef,
    private _equipmentDetailsService: EquipmentDetailsService,
    private _manageEquipmentService: ManageEquipmentService,
    private _getPrefrencesService: GETPreferencesService,
    private _touter: Router,
    private cd: ChangeDetectorRef
  ) {
    //this._toaster.setRootViewContainerRef(vcr);

  }

  ngOnInit() {
    if (this.implementToBeInspected !== undefined) {
      this.getUserPref();

      //this._inspectionService.mySubject.subscribe(val => {
      //  //console.log('behavior', val);
      //  this.reloadImplement();
      //});
      this.ImplementID = this.implementToBeInspected.ImplementId
      this.implementInspectionID = this.implementToBeInspected.ImplementInspectionId
      this.currentSMU = this.implementToBeInspected.MeterReading;
      //// this.reloadImplement();
      this.getMinMaxDate();
      this.CheckCrackSeverityListForCustomer();
      this.checkCrackObsListForCustomer();
      this.loadImplementImage();
      this.loadImplementDetails();
      this.getInspectionImages();
      this.getInspectionGeneralQuestions();
      this.getInspectionComponentTypes();
      //this.getInspectionComponents();
      if (this.implementToBeInspected != null) {
        this.getGETWearSurfaceReportSyle();
        if (this.implementToBeInspected.IncludeOverallComment == true) {
          this.OverallComment = true;
        } else {
          this.OverallComment = false;
        }
      }
      this.commentComingFrom = CommentModelComingFrom.Interpretation;
      this.inspectionImages = PhotoModelComingFrom.InterpretationInspectionImages;
      this.inspectiongeneralQuestionImage = PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel;
      this.observationImagesOnObservation = PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel;
    }
  }

  ChangeReportGrouping(componentInspection: number, event: any) {
    //console.log("componentInspection--",componentInspection,event.value)
    this.selectedReportGroup = event.value;
    if (componentInspection > 0) {
      this._inspectionService.ChangeReportingGroupType(componentInspection, event.value).subscribe((r: any) => {
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
        } else {
          this._toaster.error(r.m_Item2);
        }
      });
    }
  }

  viewImplementLevel() {
    this.selectedSchematic = -999;
    if (this.implementToBeInspected.Components) {
      this.implementToBeInspected.Components.forEach(c => {
        c.ObservationPointsFiltered = c.ObservationPoints;
      });
    }
  }

  filterObPoint(schematic: SchematicsViewModel) {
    this.selectedSchematic = schematic.Id;
    this.implementToBeInspected.Components.forEach(c => {
      if (c.ObservationPoints !== null) {
        c.ObservationPointsFiltered = c.ObservationPoints.filter(o => o.SchematicId === schematic.Id);
      }
    });
  }

  toggleComponentFlag(componentInspection: number) {
    if (componentInspection > 0) {
      this._inspectionService.toggleComponentInspectionFlag(componentInspection).subscribe((r: any) => {
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
        } else {
          this._toaster.error(r.m_Item2);
        }
      });
    }
  }

  toggleObservationPointIncludeReport(ObservationId: number) {
    if (ObservationId > 0) {
      this._inspectionService.toggleObservationInspectionIncludeReport(ObservationId).subscribe((r: any) => {
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
        } else {
          this._toaster.error(r.m_Item2);
        }
      });
    }
  }

  toggleAllObservations(componentInspection: number, value: boolean) {
    let newvalue = !value;
    //console.log("NEWWWW VALUE",newvalue, componentInspection)
    if (componentInspection > 0) {
      this._inspectionService.toggleAllObservations(componentInspection, newvalue).subscribe((r: any) => {
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
          // this.reloadImplement();
        } else {
          this._toaster.error(r.m_Item2);
        }
      });
    }
  }

  CheckComponentObservation(componentInspection: number) {
    let newlist = this.implementToBeInspected.Components.filter(x => x.ComponentId == componentInspection);

  }

  toggleComponentIncludeReport(componentInspection: number) {
    if (componentInspection > 0) {
      this._inspectionService.toggleComponentInspectionIncludeReport(componentInspection).subscribe((r: any) => {
        if (r.m_Item1) {
          this._toaster.success(r.m_Item2);
        } else {
          this._toaster.error(r.m_Item2);
        }
      });
    }
  }

  getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/*;base64,' + image);
    }
  }

  answered(question: InspectImplementQuestionViewModel, answers: InspectImplementAnswersViewModel) {
    if (this.isCreatingInspection) {
      question.Answer = answers;
      //console.log("question.Answer, answers ", question.Answer, answers);
    } else {
      this._loadingService.startLoading();
      this._inspectionService.ChangedImplementGeneralQuestion(this.implementToBeInspected.ImplementInspectionId, question, answers)
        .subscribe(r => {
          this._loadingService.finishedLoading();
          //console.log(r);
        });
    }
  }

  photoRecevied(image, ObservationPoint: InspectionObservationPointsViewModel) {
    const newPhoto = new ObservationImagesViewModel(image);
    if (ObservationPoint.ObservationImages !== undefined) {
      ObservationPoint.ObservationImages.push(newPhoto);
    } else {
      ObservationPoint.ObservationImages = [];
      ObservationPoint.ObservationImages.push(newPhoto);
    }

  }

  viewImplementImage() {
    const passingData = {
      comingFrom: PhotoModelComingFrom.ImplementImage,
      image: this.implementToBeInspected.ImplementsImage,
      implementInspection: this.implementToBeInspected.ImplementId
    };
    const viewImplementImage = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewImplementImage.afterClosed().subscribe(changes => {
      console.log("Implement Image: ", changes);
      if (changes) {
        this.implementToBeInspected.ImplementsImage = changes;
        this.implementImage = this.getImage(changes);
      }
    });
  }

  ViewInspectionImage(img: ImplementInspectionImageViewModel) {
    const passingData = {
      comingFrom: this.isCreatingInspection ?
        PhotoModelComingFrom.NewInspectionInspectionImages : PhotoModelComingFrom.InterpretationInspectionImages,
      image: img,
      implementInspection: this.implementToBeInspected
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe(changes => {
      console.log("changes", changes);
      if (changes) {
        this.getInspectionImages();
      }
    });
  }
  reloadFinish: boolean = false;

  currentInspectionDate: Date;
  reloadImplement() {
    console.log("reloadImplement", this.isCreatingInspection);
    this._loadingService.startLoading();
    if (this.isCreatingInspection) {

      if (this.selectedImplmentId === undefined) { this._loadingService.finishedLoading(); this.reloadFinish = true; return; }
      if (this.EquipmentID > 0) {
        this._inspectionService.GetInspectionTemplatesBySelectedImplementId(this.selectedImplmentId).subscribe(r => {
          this.implementToBeInspected = r;
          console.log("this.implementToBeInspected", this.implementToBeInspected);
          this.getUserPref();
          //console.log(this.implementToBeInspected);
          this.ImplementID = this.implementToBeInspected.ImplementId
          this.implementInspectionID = this.implementToBeInspected.ImplementInspectionId
          this.currentSMU = this.implementToBeInspected.MeterReading;
          this.loadImplementImage();
          this.loadImplementDetails();
          //if (this.implementToBeInspected.EquipmentId == 0)
          //  this.IsOnEquipment = false;
          //else
          this.IsOnEquipment = true;
          this.GetSequentialNumber();
          this.implementToBeInspected.InspectionDate = new Date();
          this.getMinMaxDate();
          this.originalCopy = r;
          this.viewImplementLevel();
          this._loadingService.finishedLoading();
          this.reloadFinish = true;
          //console.log(this.implementToBeInspected.GeneralQuestions);
          this.implementToBeInspected.GeneralQuestions.forEach(question => {
            if (question.PossibleAnswers && question.PossibleAnswers.length > 0) {
              if (question.Id == 3)
                question.Answer = question.PossibleAnswers.find(f => f.Id == 7);
              else if (question.Id == 4)
                question.Answer = question.PossibleAnswers.find(f => f.Id == 10);
              else if (question.Id == 5)
                question.Answer = question.PossibleAnswers.find(f => f.Id == 12);
            }
          });


        });
      }
      else {
        this._inspectionService.GetInspectionTemplatesBySelectedImplementIdOnInventory(this.selectedImplmentId).subscribe(r => {
          // console.log(r);
          this.implementToBeInspected = r;
          this.getUserPref();
          this.ImplementID = this.implementToBeInspected.ImplementId
          this.implementInspectionID = this.implementToBeInspected.ImplementInspectionId
          this.currentSMU = this.implementToBeInspected.MeterReading;
          this.loadImplementImage();
          this.loadImplementDetails();
          this.implementToBeInspected.InspectionDate = new Date();
          this.getMinMaxDate();
          this.originalCopy = r;
          this.viewImplementLevel();
          this._loadingService.finishedLoading();
          this.reloadFinish = true;
          this.IsOnEquipment = false;
          this.GetSequentialNumber();
          this.implementToBeInspected.GeneralQuestions.forEach(question => {
            if (question.PossibleAnswers && question.PossibleAnswers.length > 0) {
              if (question.Id == 3)
                question.Answer = question.PossibleAnswers.find(f => f.Id == 7);
              else if (question.Id == 4)
                question.Answer = question.PossibleAnswers.find(f => f.Id == 10);
              else if (question.Id == 5)
                question.Answer = question.PossibleAnswers.find(f => f.Id == 12);
            }
          });
        });
      }

      this.commentComingFrom = CommentModelComingFrom.NewInspection;
      this.questionComingFrom = QuestionModelComingFrom.NewInspection;
      this.inspectionImages = PhotoModelComingFrom.NewInspectionInspectionImages;
      this.inspectiongeneralQuestionImage = PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel;
      this.observationImagesOnObservation = PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel;
    }
    else if (this.implementToBeInspected !== undefined) {
      //console.log('interpretation');
      //this._inspectionService.GetImplementInspectionView(this.implementToBeInspected.ImplementInspectionId).subscribe(r => {
      //  this.implementToBeInspected = r;
      //  this.currentInspectionDate = this.implementToBeInspected.InspectionDate;
      //  this._inventoryService.returnMinDateForImplement(this.implementToBeInspected.ImplementId, this.implementToBeInspected.ImplementInspectionId)
      //    .subscribe(response => {
      //      if (response != "") {
      //        try {
      //          this.minDate2 = new Date(response);
      //        }
      //        catch (ex) {
      //          this.minDate2 = new Date();
      //        }
      //      }
      //    });

      //  this._inventoryService.returnMaxDateForImplement(this.implementToBeInspected.ImplementId, this.implementToBeInspected.ImplementInspectionId)
      //    .subscribe(response => {
      //      if (response != "") {
      //        try {
      //          this.maxDateForAction = new Date(response);
      //        }
      //        catch (ex) {
      //          this.maxDateForAction = new Date();
      //        }
      //      }
      //    });
      //  this._loadingService.finishedLoading();
      //  this.reloadFinish = true;

      //});

      this._loadingService.finishedLoading();
      this.reloadFinish = true;
      this.commentComingFrom = CommentModelComingFrom.Interpretation;
      this.inspectionImages = PhotoModelComingFrom.InterpretationInspectionImages;
      this.inspectiongeneralQuestionImage = PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel;
      this.observationImagesOnObservation = PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel;
      this.viewImplementLevel();
    }
  }

  getMinMaxDate() {
    this.currentInspectionDate = this.implementToBeInspected.InspectionDate;
    this._inventoryService.returnMinDateForImplement(this.implementToBeInspected.ImplementId, this.implementToBeInspected.ImplementInspectionId)
      //this._inventoryService.returnMinDateForImplementEvent(this.implementToBeInspected.ImplementId.toString())
      .subscribe(response => {
        console.log("this.minDate2", response);
        if (response != "") {
          try {
            this.minDate2 = new Date(response);
          }
          catch (ex) {
            this.minDate2 = new Date();
          }
        }

      });

    //this._inventoryService.returnMaxDateForImplement(this.implementToBeInspected.ImplementId, this.implementToBeInspected.ImplementInspectionId)
    //  .subscribe(response => {
    //    console.log("this.maxDateForAction", response);
    //    if (response != "") {
    //      try {
    //        this.maxDateForAction = new Date(response);
    //      }
    //      catch (ex) {
    //        this.maxDateForAction = new Date();
    //      }
    //    }
    //  });
  }

  dateChanged() {
    if (!this.isCreatingInspection) {
      if (this.implementToBeInspected !== undefined) {
        if (this.currentInspectionDate != this.implementToBeInspected.InspectionDate) {
          this._inventoryService.UpdateGETInspectionDate(this.implementToBeInspected).subscribe(res => {
            this._notification.success('Inspection Date Updated');
          })
        }
      }
    }
  }

  UpdateSMU() {
    if (!this.isCreatingInspection && this.currentSMU != this.implementToBeInspected.MeterReading) {
      this._inventoryService.returnMinMaxSMUForImplement(this.implementToBeInspected.ImplementId, this.implementToBeInspected.ImplementInspectionId).subscribe(res => {
        //console.log("res", res, this.implementToBeInspected.MeterReading)

        if (res[1] > 0) {
          if (this.implementToBeInspected.MeterReading >= res[0] && this.implementToBeInspected.MeterReading <= res[1]) {
            //console.log("answer1", this.implementToBeInspected.MeterReading)

            this._inventoryService.UpdateGETInspectionSMU(this.implementToBeInspected).subscribe(res_ => {
              if (!this.isCreatingInspection)
                this._notification.success('Inspection SMU Updated');
            })
          } else {
            this._notification.error('Inspection SMU needs to be between ' + res[0] + ' and ' + res[1]);
          }
        } else if (res[1] == 0) {
          if (this.implementToBeInspected.MeterReading >= res[0]) {
            //console.log("answer2", this.implementToBeInspected.MeterReading)

            this._inventoryService.UpdateGETInspectionSMU(this.implementToBeInspected).subscribe(_res => {
              this._notification.success('Inspection SMU Updated');
            })
          } else {
            this._notification.error('Inspection SMU needs to be greater than ' + res[0]);
          }
        }
        else {
          this._notification.error('Inspection SMU needs to be between ' + res[0] + ' and ' + res[1]);

        }
      })
    }


  }
  viewGeneralQuestionOnImplmentImage(img: GeneralQuestionImageViewModel, question: InspectImplementQuestionViewModel) {
    const passingData = {
      comingFrom: this.isCreatingInspection ?
        PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel
        : PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel,
      image: img,
      question: question,
      implementInspection: this.implementToBeInspected
    };
    const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
      width: '1032px',
      data: passingData,
    });
    viewInspectionPhoto.afterClosed().subscribe(changes => {
      console.log("changes", changes);
      if (changes && !this.isCreatingInspection) {
        this.getInspectionGeneralQuestions();
      }
    });
  }


  //viewObservationImage(img: ObservationImagesViewModel, observationPoint: InspectionObservationPointsViewModel) {
  //  const passingData = {
  //    comingFrom: this.isCreatingInspection ?
  //      PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel
  //      : PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel,
  //    image: img,
  //    inspectionObservationPoint: observationPoint,
  //  };
  //  const viewInspectionPhoto = this._dialog.open(GETViewPhotoComponent, {
  //    width: '1032px',
  //    data: passingData,
  //  });
  //  viewInspectionPhoto.afterClosed().subscribe(changes => {
  //    if (changes) {
  //      this.reloadImplement();
  //    }
  //  });
  //}

  shouldHighlight(ObservationPoint: InspectionObservationPointsViewModel): boolean {
    let result = false;
    if (ObservationPoint.ObservationListQuestions === undefined || ObservationPoint.ObservationListQuestions === null) {
      return result;
    }
    ObservationPoint.ObservationListQuestions.forEach(o => {
      if (o.Questions !== null && o.Questions !== undefined) {
        o.Questions.forEach(q => {
          if (q.Checked || (q.Images !== null && q.Images !== undefined && q.Images.length > 0)) {
            result = true;
          }
        });
      }
    });
    return result;
  }

  openObservationQuestions(ObservationPoint: InspectionObservationPointsViewModel) {
    let passingData;
    switch (this.questionComingFrom) {
      case QuestionModelComingFrom.NewInspection:
        passingData = {
          comingFrom: this.questionComingFrom,
          observation: ObservationPoint,
        };
        break;
    }

    const viewCommentModalRef = this._dialog.open(ObservationQuestionsComponent, {
      width: '1032px',
      data: passingData,

    });
    viewCommentModalRef.afterClosed().subscribe(changes => {
      if (changes) {
        // this.comment = reloadComment;
        // this.observationPoint.Comments = reloadComment;
        // this.onCommentChange.emit(reloadComment);
      }
    });
  }

  newInspectionImageUploaded(event) {
    if (event && !this.isCreatingInspection) {
      this.implementToBeInspected.InspectionImages.push(new ImplementInspectionImageViewModel(event));
      //this.reloadImplement();
    }
  }

  questionImagesUploaded(event, question: InspectImplementQuestionViewModel) {
    if (event && !this.isCreatingInspection) {
      question.Image.push(new GeneralQuestionImageViewModel(event));
      //this.reloadImplement();
    }
  }


  //getDisplayImage() {
  //  //console.log("this.selectedSchematic: ", this.selectedSchematic);
  //  if (this.selectedSchematic === -999) {
  //    if (this.implementToBeInspected.ImplementsImage)
  //      return this.getImage(this.implementToBeInspected.ImplementsImage);
  //    else {
  //      let SampleImage = "iVBORw0KGgoAAAANSUhEUgAAAHgAAABOCAIAAABkJUU1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAFN0lEQVR4Xu2c2VYiMRRF/f//sx1abWdEcBabx95w0rWKqlRRQyYg+4FlgKWyc+omuaBHk8nk4+NjuVz+zfjh/f396enpiK9eXl6m0+lisdADGVegFLGvr6/keCVad2Ed9xpmxoNfLP/8/GhoRIu3tzce+/7+NuPMIL6+vtBIQTbjNRuiQWnHuBln+kB+qcOz2awIckFVtGA20M3MmHGmA5+fn5Rfbs14E7toYE6YGQpNfXIyFVA0X9PiqlG0YH5ytNtRkLcq2iIaukzXYYIQLnqKchcz20WL9gJ0gHQMckFX0cC8NS2pB0WvIBf0EC20STzYaHOmG7Zo9RYtKNmHFm1e7PPzM0E2454MFA3MKkWqcv7ZVxTkMWfm4aIFM8w873G0XR2Vx4oG5plo72VDqtIYGoMD0YI5J9p702slPSh2mB5noqFov5rxzuKjHroULQZvgFLA3wrvXjQUO6EdWiT5Vb0u7F5Ei76H1IgEaDB4FA2kg3NNyg2pYL+hX9GCpKRZtUO+vxFCNJCXVad1Pjfj2CjIIVeRQKKFou21FHYhyr4oqGhQlMCMw8JP13bIjAMSWrTQKh+4ITW+MTSGOKKF9q0BTu0pHFljiobuvbFlA+bhZvSpoGCLXhORRQs1pAoXRmFJIvNxdXX1u8bFxUXLmqbG0PgOpxOSEA1YxiZyMf7nP0URp6D/auD29lbPKcN383qeHkAqogWiHx4ejo+PMXh6eqouJRNwdnYmrXVOTk4qoUYuu5rU3vpJTjQxnEwmKC7CyNBIXYNZMIM1d3d3PNmKvkMKpCW6AEe4RjGlWVq5pUqwcyC/QOW9v78n9XLNF3V4frnQxyUh0cjleqccU52pFeXYsu5VSoEMYpyZME+qcX19nUVbYIdgDG2CZYTyBG6p4JeXl2w2KBdSz/Q0uc6i7ZBlLYMVdNDgtrIkEnkKOg9xzqxUbZFF27GKJr88RJatGw/8Ktc3NzfmrhJZtB2raO5E1uPjoxnXQDFPYNdsxiWyaDtW0aobLSve+fk5TyDXZlwii7bTIpoCYsY1JJoybcYlsmg7VtFsRZDFltmMa7AXzKWjH1bRFA0eIrAcQMxdm6hnxNnEjEtk0XasotlXSOVsNqvv4VgkUZm3d/2wigYOLHpbhBWPPQZFGUi6yjcHlqYKnkXbaRINuFYnrwL765Z1Mou20yIaKA6IY9GjUABx5hTeVLhFFm2nXXQBxq0VuU4WXYWELhYLlju9O+UKNoVZtIGlDL9eP8HEEprCJ6RiikYB5YI4m7E3+BH8IPVaYxFHNEF+DvuJIV06YMbBiSCajVqsfCnaAa6hOkFFs+IRZB00IkLJJtpk3IyDEE40J+lpMv8iS3+ypzcNwhBCNHLT+cRQGa4trrAwc+9dNC8Gy4Gv0+4EC4FH0bo8rT2K1FBZ8/qJXi+iyW9qH33biu+F2r1o9m2xtlDj0RnKR7Rdiia/q78H2vH/vsQvz+aPK9Ltq3AmmghT5nY0yHWINi/H4anKgWhFYNeDXIeq7TDaY0UHawzFQi9wfLSHi2aeWaYJshnvL8Ula8aDGCja1TzvEFy1Y67d3qIV5JAdzqQg18MaUv1Eq8Pp9QSVPjoo9D3xdhWNXLY70Tuc6aAeTveGVCfRagU42eXsE1gm2h0bUltEK8g70RiKhVK4NdqNoskvK96wwn9oYBnX7dG2i97pxlAsuO7R3bRTqIomv4N3MBmi3dRr3RA9ck+eEdaGlBGtIEMOshOIthpSZizROcieKDcqjsa3SzItUCFWhufzf5LmIP5DdRB8AAAAAElFTkSuQmCC";
  //      return this.getImage(SampleImage);
  //    }
  //  } else {
  //    const schematic = this.implementToBeInspected.AvailableShematics.find(s => s.Id === this.selectedSchematic);
  //    if (schematic !== undefined) {
  //      return this.getImage(schematic.Image);
  //    }
  //  }
  //}


  inclideOnReportModelChanged(event: boolean) {
    this.implementToBeInspected.IncludeOnReport = event;
    this._loadingService.startLoading();
    if (!this.isCreatingInspection) {
      this._inspectionService.UpdateIncludeOnReport(this.implementToBeInspected.ImplementInspectionId, event)
        .subscribe(r => {
          this._loadingService.finishedLoading();
        });
    }
  }
  IncludeCommentOnReport(value: boolean) {
    //this.implementToBeInspected.IncludeOverallComment = value;
    this._loadingService.startLoading();
    if (!this.isCreatingInspection) {
      this._inspectionService.UpdateIncludeCommentOnReport(this.implementToBeInspected.ImplementInspectionId, this.implementToBeInspected.IncludeOverallComment)
        .subscribe(r => {
          this._loadingService.finishedLoading();
        });
    }
  }

  updateInterpretationComment(comment, value) {
    const model = new InspectionOverallCommentUpdateCommentViewModel();
    model.ImplementInspectionId = this.implementToBeInspected.ImplementInspectionId;
    if (value == 1) {
      model.CommentContent = comment
    } else if (value == 2) {
      model.Recommendation = comment;
    } else {
      model.WorkRequired = comment;
    }
    // console.log(comment);
    this._loadingService.startLoading();
    this._inspectionService.updateOverallInspectionComment(model)
      .subscribe(r => {
        //console.log(r);
        this._loadingService.finishedLoading();
      });
  }

  getGETWearSurfaceReportSyle() {
    this._equipmentDetailsService.GetGETWearSurfaceReportStyle(this.implementToBeInspected.EquipmentId, this.ImplementID).subscribe(res => {
      if (res != null) {
        this.wearStyleId = res;
      }
    })
  }
  //date:string
  DownloadPDF(date: string) {
    this.getGETWearSurfaceReportSyle();
    //this.date = inspectionDate.toString();
    //console.log("DATE", date, this.wearStyleId)
    var dateParts = date.split('/');
    var months = [
      { id: "01", name: "Jan" },
      { id: "02", name: "Feb" },
      { id: "03", name: "Mar" },
      { id: "04", name: "Apr" },
      { id: "05", name: "May" },
      { id: "06", name: "Jun" },
      { id: "07", name: "Jul" },
      { id: "08", name: "Aug" },
      { id: "09", name: "Sep" },
      { id: "10", name: "Oct" },
      { id: "11", name: "Nov" },
      { id: "12", name: "Dec" }
    ];

    var day = dateParts[0];
    var month = months.find(f => f.name == dateParts[1]).id;
    var year = dateParts[2];

    var dateParsed = year + month + day;

    //window.open(this.appUris.UCUri + 'api/GETinspection/GetPdf?id=' + this.implementToBeInspected.EquipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
    window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdf?id=' + this.implementToBeInspected.EquipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
  }

  DownloadTelerikPDF() {

    //window.open(this.appUris.UCUri + 'api/GETinspection/GetPdf?inspectionid=' + this.implementToBeInspected.ImplementInspectionId + '&EquipmentId=' + this.implementToBeInspected.EquipmentId + '&GetType=' + this.implementToBeInspected.GETTypeId + '&styleId=' + this.wearStyleId, '_blank');
    window.open(this._appService.getBaseURL() + 'api/GETinspection/GetPdf?inspectionid=' + this.implementToBeInspected.ImplementInspectionId + '&EquipmentId=' + this.implementToBeInspected.EquipmentId + '&GetType=' + this.implementToBeInspected.GETTypeId + '&styleId=' + this.wearStyleId, '_blank');
  }

  getEvalClass(worn: number) {
    return this._inspectionService.getEvalClass(worn);
  }
  getEvalClass2(worn: number) {
    return this._inspectionService.getEvalClass2(worn);
  }

  GenerateTrayPDF(date: string) {
    this.getGETWearSurfaceReportSyle();
    //this.date = inspectionDate.toString();
    var dateParts = date.split('/');
    var months = [
      { id: "01", name: "Jan" },
      { id: "02", name: "Feb" },
      { id: "03", name: "Mar" },
      { id: "04", name: "Apr" },
      { id: "05", name: "May" },
      { id: "06", name: "Jun" },
      { id: "07", name: "Jul" },
      { id: "08", name: "Aug" },
      { id: "09", name: "Sep" },
      { id: "10", name: "Oct" },
      { id: "11", name: "Nov" },
      { id: "12", name: "Dec" }
    ];

    var day = dateParts[0];
    var month = months.find(f => f.name == dateParts[1]).id;
    var year = dateParts[2];

    var dateParsed = year + month + day;

    //window.open(this.appUris.UCUri + 'api/GETinspection/GetTrayPdf?id=' + this.implementToBeInspected.EquipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
    window.open(this._appService.getBaseURL() + 'api/GETinspection/GetTrayPdf?id=' + this.implementToBeInspected.EquipmentId + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
  }

  //GenerateTrayTelerikPDF(date:string){
  //    window.open(this.appUris.UCUri + 'api/GETinspection/GetPdf?inspectionid=' + this.implementToBeInspected.ImplementInspectionId + '&EquipmentId=' + this.implementToBeInspected.EquipmentId+ '&GetType=' + this.implementToBeInspected.GETTypeId + '&styleId=' + this.wearStyleId, '_blank');
  //}

  getImage_(image: string) {
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

  //loadImplementDetails() {
  //  this.isLoading = true
  //  this._moduleService.GetSchematicsForImplement(this.ImplementID).subscribe(details => {
  //    //this.ImplementForEquipmentDetails = details;
  //    //this.SchematicAndObservationPointList = this.ImplementForEquipmentDetails[0].SchematicAndObservationPoints
  //    this.SchematicAndObservationPointList = details[0].SchematicAndObservationPoints;
  //    this.isLoading = false
  //  });
  //}

  loadImplementDetails() {
    this.isLoading = true
    this._moduleService.getSchematicsImagesForImplement(this.ImplementID).subscribe(details => {
      console.log("details", details);
      this.ImplementForEquipmentDetails = details;
      this.SchematicAndObservationPointList = this.ImplementForEquipmentDetails[0].SchematicAndObservationPoints
      //this.SchematicAndObservationPointList = details[0].SchematicAndObservationPoints;
      this.isLoading = false
    });
  }

  componentList: ComponentVM[];
  loadComponentList(schematicId: number) {
    this._implementService.ReturnGETSchematicComponents(this.ImplementID, schematicId).subscribe(result => {
      this.componentList = result
    }, error => { console.log(error); });
  }

  obsDetails_: ObservationPointVM[];
  ObservationPointDetails: ComponentObservationPointDetails[];

  openSchematicWindow(SchematicImage: SchematicAndObservationPointDetails) {
    if (this.isCreatingInspection)
      return;
    this.isLoading = true;
    let arr_ = [];
    this._moduleService.getSchematicsObservationPointsDetails(this.ImplementID, SchematicImage.Schematic.Id).subscribe(details => {
      SchematicImage.ObservationPoints = details;
      this._moduleService.getSchematicImageBaseString(SchematicImage.Schematic.Id).subscribe(r => {
        if (r) {
          SchematicImage.Schematic.Data = r;
        }
        this._implementService.ReturnGETSchematicComponents(this.ImplementID, SchematicImage.Schematic.Id).subscribe(result => {
          this.componentList = result
          //this.loadComponentList(SchematicImage.Schematic.Id);
          SchematicImage.ObservationPoints.map(x => {
            var neModl = new ObservationPointVM();
            neModl.ObservationPointId = x.Id;
            neModl.ObservationPointPosX = x.PositionX;
            neModl.ObservationPointPosY = x.PositionY;
            neModl.EndObservationPointPosX = x.EndPositionX;
            neModl.EndObservationPointPosY = x.EndPositionY;
            neModl.isCrackFixed = x.IsCrackFixed;
            neModl.ObservationPointName = x.Name;
            neModl.observationPointTypeId = x.ObPointTypeId;
            neModl.WornPct = x.WornPct;
            neModl.InspectionDate = x.InspectionDate;
            neModl.pointLedgend = 3;
            neModl.CrackStatusId = x.CrackStatusId;
            neModl.ColorCode = x.ColorCode;
            neModl.CrackStatus = x.CrackStatus;
            neModl.InstallDate = x.InstallDate;
            neModl.CurrentLength = Number((parseFloat(x.CurrentLength ?? '0') || 0).toFixed(1));
            arr_.push(neModl)
          });
          this.isLoading = false
          //console.log("SchematicImage.ObservationPoints", SchematicImage.ObservationPoints)
          const addSectionDialog = this._dialog.open(AddCrackObsPointDialogComponent, {
            width: '1300px',
            //height: '1075px',
            disableClose: true,
            data: {
              obsDetails: arr_,
              schematic: SchematicImage.Schematic.Data,
              componentList: this.componentList,
              schematicId: SchematicImage.Schematic.Id,
              IsGETInspection: true,
              inspectionDate: this.implementToBeInspected.InspectionDate,
              implementInspectionId: this.implementToBeInspected.ImplementInspectionId,
              isGlobalImg: true,
              implementId: this.ImplementID,
              TypeID: 2,
              disabledCrackOption: false
            }
          });
          addSectionDialog.afterClosed().subscribe(ObsID => {
            if (ObsID > 0) {
              //console.log("details", ObsID)
              this.loadImplementDetails();
              // this.getInspectionComponents();
              //this._inspectionService.recordComponentInspectionForObsPoint(ObsID, this.implementInspectionID).subscribe(res => {
              //        //console.log(res)
              //        //this.updateObs.emit(true);
              //        //this.loadImplementDetails();
              //})
            } else {

            }
          });
        });
      });
    });
  }

  commentChanged(Id: number, value: any) {
    this._inspectionService.UpdateReportSummaryComment(Id, value).subscribe((r: any) => {
      if (r.m_Item1) {
        this._toaster.success(r.m_Item2);
      } else {
        this._toaster.error(r.m_Item2);
      }
    });
  }

  getInspectionImages() {
    this._inspectionService.getInspectionImages(this.implementInspectionID).subscribe(r => {
      if (r) {
        this.implementToBeInspected.InspectionImages = r;
      }
    });
  }

  getInspectionGeneralQuestions() {
    this._inspectionService.getInspectionGeneralQuestions(this.implementInspectionID).subscribe(r => {
      if (r) {
        this.implementToBeInspected.GeneralQuestions = r;
      }
    });
  }


  //getInspectionComponentTypes() {
  //  this._inspectionService.getInspectionComponentTypes(this.ImplementID, this.implementInspectionID).subscribe(r => {
  //    if (r) {
  //      this.implementToBeInspected.ComponentTypes = r;
  //      this.currentTypeIndex = 0;
  //      console.log("Reset currentIndex to:", this.currentTypeIndex);

  //    }
  //  });
  //}

  observationsMap: { [key: number]: any[] } = {};


  getInspectionComponentTypes() {
    this._inspectionService
      .getInspectionComponentTypes(this.ImplementID, this.implementInspectionID)
      .subscribe(types => {
        this.implementToBeInspected.ComponentTypes = types || [];

        // console.log("Component types loaded:", this.implementToBeInspected.ComponentTypes.length);
        this.loadSequential(0);
      });
  }



  loadSequential(index: number) {
    if (index >= this.implementToBeInspected.ComponentTypes.length) return;

    const type = this.implementToBeInspected.ComponentTypes[index];

    this._inspectionService
      .GetAllObservationPointsByCompType(type.SchematicId, type.componentTypeId, this.implementInspectionID)
      .subscribe(observations => {
        console.log("this.observations289734", observations);
        if (observations?.length > 0) {
          observations.forEach(obs => {

            obs.ObservationMeasurements = obs.ObservationMeasurementsJson
              ? JSON.parse(obs.ObservationMeasurementsJson)
              : []
            //console.log("obs.ObservationMeasurements", obs.ObservationMeasurements);

            obs.ObsList = obs.ObsListJson
              ? JSON.parse(obs.ObsListJson)
              : []

            obs.obsSeverityList = obs.ObsSeverityJson
              ? JSON.parse(obs.ObsSeverityJson)
              : []

            obs.ObservationImages =
              obs.ObservationImagesJson
                ? JSON.parse(obs.ObservationImagesJson)
                : [];

            obs.severityIDs =
              obs.SeverityIDsJson
                ? JSON.parse(obs.SeverityIDsJson)
                : [];

            if (obs?.ObsList?.length > 0 && obs?.ObservationTypeName === 'Crack') {
              obs.obsId = obs.severityIDs?.[0] ?? null;
            }
          });
        }
        const key = `${type.componentTypeId}_${type.SchematicId}`;
        this.observationsMap[key] = observations;
        //console.log("index: ", index);
        //console.log("this.observationsMap: ", this.observationsMap);
        this.loadSequential(index + 1);
      });
  }

  //getInspectionComponents() {
  //  this._inspectionService.getInspectionComponents(this.implementInspectionID).subscribe(r => {
  //    if (r) {
  //      this.implementToBeInspected.Components = r;
  //      this.implementToBeInspected.Components.map(x => {
  //        if (x.ReportGrouping == null) {
  //          x.ReportGrouping = -1;
  //        }
  //      })
  //     //console.log("this.implementToBeInspected.Components", this.implementToBeInspected.Components);
  //    }
  //  });
  //}

  loadImplementImage() {
    if (this.implementToBeInspected.ImplementsImage) {
      //this.implementImage = this.getImage(this.implementToBeInspected.ImplementsImage);
      this.implementImage = this.implementToBeInspected.ImplementsImage;
    }
    else {
      let SampleImage = "iVBORw0KGgoAAAANSUhEUgAAAHgAAABOCAIAAABkJUU1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAZdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuMTZEaa/1AAAFN0lEQVR4Xu2c2VYiMRRF/f//sx1abWdEcBabx95w0rWKqlRRQyYg+4FlgKWyc+omuaBHk8nk4+NjuVz+zfjh/f396enpiK9eXl6m0+lisdADGVegFLGvr6/keCVad2Ed9xpmxoNfLP/8/GhoRIu3tzce+/7+NuPMIL6+vtBIQTbjNRuiQWnHuBln+kB+qcOz2awIckFVtGA20M3MmHGmA5+fn5Rfbs14E7toYE6YGQpNfXIyFVA0X9PiqlG0YH5ytNtRkLcq2iIaukzXYYIQLnqKchcz20WL9gJ0gHQMckFX0cC8NS2pB0WvIBf0EC20STzYaHOmG7Zo9RYtKNmHFm1e7PPzM0E2454MFA3MKkWqcv7ZVxTkMWfm4aIFM8w873G0XR2Vx4oG5plo72VDqtIYGoMD0YI5J9p702slPSh2mB5noqFov5rxzuKjHroULQZvgFLA3wrvXjQUO6EdWiT5Vb0u7F5Ei76H1IgEaDB4FA2kg3NNyg2pYL+hX9GCpKRZtUO+vxFCNJCXVad1Pjfj2CjIIVeRQKKFou21FHYhyr4oqGhQlMCMw8JP13bIjAMSWrTQKh+4ITW+MTSGOKKF9q0BTu0pHFljiobuvbFlA+bhZvSpoGCLXhORRQs1pAoXRmFJIvNxdXX1u8bFxUXLmqbG0PgOpxOSEA1YxiZyMf7nP0URp6D/auD29lbPKcN383qeHkAqogWiHx4ejo+PMXh6eqouJRNwdnYmrXVOTk4qoUYuu5rU3vpJTjQxnEwmKC7CyNBIXYNZMIM1d3d3PNmKvkMKpCW6AEe4RjGlWVq5pUqwcyC/QOW9v78n9XLNF3V4frnQxyUh0cjleqccU52pFeXYsu5VSoEMYpyZME+qcX19nUVbYIdgDG2CZYTyBG6p4JeXl2w2KBdSz/Q0uc6i7ZBlLYMVdNDgtrIkEnkKOg9xzqxUbZFF27GKJr88RJatGw/8Ktc3NzfmrhJZtB2raO5E1uPjoxnXQDFPYNdsxiWyaDtW0aobLSve+fk5TyDXZlwii7bTIpoCYsY1JJoybcYlsmg7VtFsRZDFltmMa7AXzKWjH1bRFA0eIrAcQMxdm6hnxNnEjEtk0XasotlXSOVsNqvv4VgkUZm3d/2wigYOLHpbhBWPPQZFGUi6yjcHlqYKnkXbaRINuFYnrwL765Z1Mou20yIaKA6IY9GjUABx5hTeVLhFFm2nXXQBxq0VuU4WXYWELhYLlju9O+UKNoVZtIGlDL9eP8HEEprCJ6RiikYB5YI4m7E3+BH8IPVaYxFHNEF+DvuJIV06YMbBiSCajVqsfCnaAa6hOkFFs+IRZB00IkLJJtpk3IyDEE40J+lpMv8iS3+ypzcNwhBCNHLT+cRQGa4trrAwc+9dNC8Gy4Gv0+4EC4FH0bo8rT2K1FBZ8/qJXi+iyW9qH33biu+F2r1o9m2xtlDj0RnKR7Rdiia/q78H2vH/vsQvz+aPK9Ltq3AmmghT5nY0yHWINi/H4anKgWhFYNeDXIeq7TDaY0UHawzFQi9wfLSHi2aeWaYJshnvL8Ula8aDGCja1TzvEFy1Y67d3qIV5JAdzqQg18MaUv1Eq8Pp9QSVPjoo9D3xdhWNXLY70Tuc6aAeTveGVCfRagU42eXsE1gm2h0bUltEK8g70RiKhVK4NdqNoskvK96wwn9oYBnX7dG2i97pxlAsuO7R3bRTqIomv4N3MBmi3dRr3RA9ck+eEdaGlBGtIEMOshOIthpSZizROcieKDcqjsa3SzItUCFWhufzf5LmIP5DdRB8AAAAAElFTkSuQmCC";
      this.implementToBeInspected.ImplementsImage = SampleImage;
      this.implementImage = this.getImage(SampleImage);
    }
  }

  GetSequentialNumber() {
    if (this.isCreatingInspection) {
      this._inspectionService.GetSequentialNumber().subscribe(result => {
        if (result != null) {
          const currentYear: number = new Date().getFullYear();
          this.implementToBeInspected.JobFileNo = 'JF-' + currentYear + '-' + result.toString().padStart(4, '0') + (this.UnitNumber !== undefined ? '-' + this.UnitNumber : "");
          this.implementToBeInspected.RepairRequestNo = 'RR-' + currentYear + '-' + result.toString().padStart(4, '0') + (this.UnitNumber !== undefined ? '-' + this.UnitNumber : "");
        }
      })
    }
  }

  CheckCrackSeverityListForCustomer() {
    this._inspectionService.CheckCrackSeverityListForCustomer(this.implementToBeInspected.EquipmentId).subscribe(r => {
      this.CrackSeverityList = r;
      //console.log("this.crackSeverityList:", this.CrackSeverityList, this.implementToBeInspected.EquipmentId);
    });
  }

  checkCrackObsListForCustomer() {
    this._inspectionService.checkCrackObsListForCustomer(this.implementToBeInspected.EquipmentId).subscribe(r => {
      this.crackObsList = r;
      //console.log("this.crackObsList:", this.crackObsList, this.implementToBeInspected.EquipmentId);
    });
  }

  equipmentDetails: EquipmentDetailsParams;

  getUserPref() {
    this._getPrefrencesService.getUserPreferences().subscribe(r => {
      this.userPref = r.UnitOfMeasurementName;
      //console.log("userPref", this.userPref);
    })
  }

  SaveInspection() {
    const vaildate = this.implementToBeInspected.GeneralQuestions
      .find(q => q.Answer.Id === 0 && (!q.IsAnswerOptional || q.Image.length > 0));
    //console.log(" this.implementToBeInspected.GeneralQuestions,", this.implementToBeInspected.GeneralQuestions, vaildate);
    if (vaildate === undefined) {
      const request: SMUValidationCheckRequest = {
        equipmentId: 0,
        actionDate: this.implementToBeInspected.InspectionDate.toISOString(),
        getAuto: this.implementToBeInspected.ImplementId,
        actionSMU: this.implementToBeInspected.MeterReading
      };
      console.log("SMUValidationCheckRequest,", request);
      this._manageEquipmentService.smuValidationCheck(request).subscribe((res: any) => {
        if (res.Status == 0) {
          this._toaster.error(res.Message);
        }
        else {
          this.isLoading = true;
          this._inspectionService.saveNewImplementInspection(this.implementToBeInspected).subscribe((r: any) => {
            //this._toaster.setRootViewContainerRef(this.vcr);
            // console.log("r", r)
            if (r.m_Item1 > 0) {
              this._toaster.success('Saved Inspection successfully');
              setTimeout(() => {
                this.isLoading = false;
                //this._touter.navigate(['equipment/', + this.equipmentId]);
                // this._touter.navigate(['in/', + this.equipmentId]);
                if (this.EquipmentID > 0)
                  this._touter.navigate(['/get-interpretation/inspection', this.EquipmentID, r.m_Item1]);
                else
                  this._touter.navigate(['/get-interpretation/inspection', 0, r.m_Item1]);
              }, 2000);
            } else {
              this.isLoading = false;
              this._toaster.error('Failed to Save, SMU needs to be greater than ' + r.m_Item2);
            }
          });
        }
      });
    } else {
      //this._toaster.setRootViewContainerRef(this.vcr);
      this._toaster.warn('Please can you complete the Inspection Details');
    }
  }
  onWorkOrderFocusOut(workOrder: string) {
    if (!this.isCreatingInspection) {
      this._inspectionService.UpdateWorkOrder(this.implementInspectionID, workOrder).subscribe(result => {
        if (result != null) {
          if (!this.isCreatingInspection)
            this._toaster.success('Work order updated successfully.');
        }
      });
    }
  }


  //onChildLoaded() {
  //  this.currentIndex++;
  //}




}
